// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"66afdd08","869":"72486d13","984":"9e4dc67d"}[chunkId] + ".chunk.css";
};